import {
  useAuthControllerWhoamiQuery,
  useVirtualBalanceControllerIncreaseUserBalanceMutation,
} from '../../../app/store/api/tunedRestApi';

export const useIncreaseBalance = () => {
  const [increaseBalance] = useVirtualBalanceControllerIncreaseUserBalanceMutation();
  const { data: user } = useAuthControllerWhoamiQuery();

  const handleIncreaseBalance = async (amount: string) => {
    if (!user) return;

    await increaseBalance({
      amount,
      userId: user.id,
    });
  };

  return {
    handleIncreaseBalance,
  };
};
